import * as React from "react";
import { styled } from "sharedUI/styles";
import { connect } from "react-redux";
import copyToClipboard from "copy-to-clipboard";
import InputLabel from "designer/ui/smart/input-label/input-label";
import { RootState } from "store/types";
import { Button } from "designer/ui/smart/button/button-style";
import AppIcon from "common/app-icon";

interface TeamInviteLinkProps {
    readonly orgID: string;
    readonly inviteLink: string;
    getInviteLink: (createNew?: boolean) => Promise<void>;
}

export const TeamInviteStyle = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${p => p.theme.bgFront};

    > .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        > .resetLink {
            cursor: pointer;
            display: flex;
            align-items: center;
            font-size: 13px;
            color: ${p => p.theme.n500};

            > .reloadArrow {
                margin-right: 8px;
            }

            &:hover {
                color: ${p => p.theme.n800};
                font-weight: 400;
            }
        }
    }

    > .links {
        display: flex;

        input {
            cursor: pointer;
        }

        > .link {
            flex-grow: 1;

            > div {
                margin: 0 10px 0 0;
            }
        }
    }
`;

const TeamInviteLinkImpl: React.FunctionComponent<TeamInviteLinkProps> = p => {
    const { getInviteLink, inviteLink } = p;

    const copyTeamInviteLink = React.useCallback(async () => {
        copyToClipboard(inviteLink);
    }, [inviteLink]);

    const onResetLink = React.useCallback(async () => {
        await getInviteLink(true);
    }, [getInviteLink]);

    return (
        <TeamInviteStyle>
            <div className="header">
                <h3>Invite via Link</h3>
                <button className="resetLink" onClick={onResetLink}>
                    <AppIcon icon="reloadArrow" size={14} className="reloadArrow" />
                    Reset Link
                </button>
            </div>
            <div className="links">
                <div className="link" onClick={copyTeamInviteLink}>
                    <InputLabel placeholder={inviteLink} label={undefined} disabled={true} />
                </div>
                <Button onClick={copyTeamInviteLink} variant="filled">
                    Copy
                </Button>
            </div>
        </TeamInviteStyle>
    );
};

const mapState = (state: RootState) => ({
    organizations: state.organizations,
    userData: state.userData,
});

const TeamInviteLink = connect(mapState)(TeamInviteLinkImpl);
export default TeamInviteLink;
